/* Motion — fade-and-rise on scroll. IntersectionObserver + CSS only.
   No GSAP, no ScrollTrigger, no smooth-scroll library, nothing that loops. */
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const items = document.querySelectorAll('[data-reveal]');

if (reduce || !('IntersectionObserver' in window)) {
  items.forEach(el => el.classList.add('is-in'));
} else {
  // One stagger pass per section: index within the nearest [data-stagger] parent.
  const io = new IntersectionObserver((entries, obs) => {
    for (const e of entries) {
      if (!e.isIntersecting) continue;
      const group = e.target.closest('[data-stagger]');
      if (group) {
        const sibs = [...group.querySelectorAll('[data-reveal]')];
        e.target.style.setProperty('--d', Math.min(sibs.indexOf(e.target), 6) * 80 + 'ms');
      }
      e.target.classList.add('is-in');
      obs.unobserve(e.target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  items.forEach(el => io.observe(el));
}
